
	import Vue from 'vue';
	import {Component, Emit, Prop, Watch} from 'vue-property-decorator';
	import {IItem} from "@/models/IItem";
	import IItemIconUrls from "@/models/IItemIconUrls";

	@Component
	export default class ItemSetIconUrlDialog extends Vue {

		@Prop({type: Boolean, default: false})
		public open!: boolean;

		@Prop({type: Object, required: true})
		public item!: IItem;

		public loading: boolean = false;
		public iconUrls: IItemIconUrls | null = null;
		public iconUrl: string | null = null;

		@Watch('item.has_icon')
		private onItemHasIconChanged(): void {
			this.loadIconUrls();
		}

		@Watch('open', {immediate: true})
		private onOpenChanged(value: boolean): void {
			if (value) {
				this.loadIconUrls();
			} else {
				this.iconUrls = null;
				this.iconUrl = null;
			}
		}

		@Emit('cancel')
		public cancel(): void {
			//do nothing
		}

		@Emit('save')
		public save(url: string | null): string | null {
			return url;
		}

		private loadIconUrls(): void {
			this.loading = true;
			this.$itemService.iconUrls(this.item.id)
				.then(data => {
					this.iconUrls = data;
					this.iconUrl = this.iconUrls.icon_url;
				})
				.catch(err => console.error(err))
				.finally(() => this.loading = false);
		}

		public trySave(): void {
			this.loading = true;
			this.$store.dispatch('item/setIconUrl', {id: this.item.id, url: this.iconUrl})
				.then(() => this.save(this.iconUrl))
				.finally(() => this.loading = false);
		}

	}
